$('#signout').click(() => {
  let logoutUrl = templateData('logoutUrl');
  let redirectUrl = templateData('redirectUrl', '/');
  $.ajax({
    url: logoutUrl,
    method: 'POST',
    success: () => {
      location.href = redirectUrl;
    },
  });
});
